const CouponModal = {
  storageKey: 'vnda:coupon-modal:dismissed',
  modal: null,
  dialog: null,
  lastFocusedElement: null,
  closeTimer: null,

  isDismissed() {
    try {
      return window.localStorage.getItem(this.storageKey) === 'true';
    } catch (_error) {
      return false;
    }
  },

  rememberDismissal() {
    try {
      window.localStorage.setItem(this.storageKey, 'true');
    } catch (_error) {
      // The modal still closes when storage is unavailable.
    }
  },

  open() {
    this.lastFocusedElement = document.activeElement;
    this.modal.hidden = false;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('-coupon-modal-open');

    window.requestAnimationFrame(() => {
      this.modal.classList.add('-active');
      this.modal.querySelector('[data-close-coupon-modal]')?.focus();
    });
  },

  close() {
    this.rememberDismissal();
    this.modal.classList.remove('-active');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('-coupon-modal-open');
    document.removeEventListener('keydown', this.handleKeydown);

    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      this.modal.hidden = true;
      this.lastFocusedElement?.focus();
    }, 250);
  },

  fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (_error) {
      copied = false;
    }

    textArea.remove();
    return copied;
  },

  async copyText(text) {
    if (!navigator.clipboard?.writeText) return this.fallbackCopy(text);

    const copied = await Promise.race([
      navigator.clipboard.writeText(text).then(() => true).catch(() => false),
      new Promise((resolve) => window.setTimeout(() => resolve(false), 750)),
    ]);

    return copied || this.fallbackCopy(text);
  },

  async copyCoupon(button) {
    const couponCode = button.closest('.coupon-modal__item')?.querySelector('[data-coupon-code]')?.textContent?.trim();
    if (!couponCode) return;

    const copied = await this.copyText(couponCode);

    const label = button.querySelector('[data-copy-label]');
    if (!label) return;

    label.textContent = copied ? 'Copiado!' : 'Tente novamente';
    button.classList.toggle('-copied', copied);

    window.clearTimeout(button.copyResetTimer);
    button.copyResetTimer = window.setTimeout(() => {
      label.textContent = 'Copiar';
      button.classList.remove('-copied');
    }, 2000);
  },

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(this.dialog.querySelectorAll('button:not([disabled])'));
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  },

  init() {
    const modal = document.querySelector('[data-coupon-modal]');
    if (!modal || this.isDismissed()) return;

    const dialog = modal.querySelector('.coupon-modal__dialog');
    const closeButtons = modal.querySelectorAll('[data-close-coupon-modal]');
    if (!dialog || closeButtons.length === 0) return;

    this.modal = modal;
    this.dialog = dialog;
    this.handleKeydown = this.handleKeydown.bind(this);

    closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    modal.querySelectorAll('[data-copy-coupon]').forEach((button) => {
      button.addEventListener('click', () => this.copyCoupon(button));
    });
    document.addEventListener('keydown', this.handleKeydown);

    this.open();
  },
};

export default CouponModal;
